import { assertParams } from '../utils'

/**
 * SSO For Web Game 플로우 진행을 위해 필요한 필수 파라미터 존재 여부를 검증합니다.
 */
export const validateParams = async (context) => {
  const requiredParams = [
    'gid',
    'targetGid',
    'ticket',
    'redirectUrl',
    'packageName',
  ]

  // 에러 발생 시 throw 후 종료
  assertParams({
    target: context,
    fields: requiredParams,
    messagePrefix: 'SSO For Web Game: ',
  })
}
